import React from "react"
import Image from "@components/image"
import { uid } from "react-uid"
import ImageLabels from "@components/image/imageLabels"

const ImageBlock = ({ image, width, title, alt, wrapperClassName, className, to, href }) => {
  if (!image) return;

  const { labels, key, alt: altText } = image
  return (
    <div key={key || `image-${uid}`} className={`relative w-full h-full ${wrapperClassName || 'flex flex-col gap-y-5'}`}>
      {title && <h2 tabIndex={0} className="pl-0 md:pl-10">{title}</h2>}
      <Image
        image={image}
        maxWidth={width}
        width={image?.width}
        height={image?.height}
        alt={alt || altText}
        to={to || href}
        className={`max-h-[90vh] rounded-xl overflow-hidden ${className || ''}`} />
      {labels && <ImageLabels labels={labels} />}
    </div>
  )
}

export default ImageBlock
